export default __webpack_public_path__ + "static/media/person.2b906862.png";